function swiperInitHandler(swiperElement, options) {
  const swiper = new Swiper(swiperElement, options);
}

const imageTextSlides = document.querySelectorAll('.image__text-slider__swiper');
imageTextSlides.forEach(sliderElement => {
  swiperInitHandler(sliderElement, {
    slidesPerView: 1,
    spaceBetween: 25,
    speed: 700,
    effect: 'slide',
    simulateTouch: true,
    touchRatio: 1.2,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      formatFractionCurrent: (n) => n,
      formatFractionTotal: (n) => n,
    }
  })
});